<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
    >
      <template v-slot:displayAvatar="{ row }">
        <el-avatar
          shape="square"
          :size="50"
          :src="row.memImgUrl || defaultAvatar"
        />
      </template>
      <template v-slot:displayName="{ row }">
        <div>{{ row.userName }}</div>
        <div>{{ row.userPost }}</div>
      </template>
      <template v-slot:displayContacts="{ row }">
        <div>{{ row.mobileNumber }}</div>
        <div>{{ row.emailAddress }}</div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyDate }}</div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      tableColumns: tableColumns(this),
    }
  },
}
</script>
